// App-wide magic values. Additive — call sites are migrated in a later task.

/** apiClient request timeout (ms). Matches the current hardcoded default in api/apiClient.ts. */
export const API_TIMEOUT_MS = 15000;

/** Max upload size in bytes. Shared by every upload flow; keep in sync with BlobStorageService.MAX_FILE_SIZE_BYTES. */
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024;
export const MAX_UPLOAD_LABEL = '25 MB';

/** Delay before focusing a just-revealed search input (ms). `setTimeout(..., 50)` ×16. */
export const FOCUS_DELAY_MS = 50;

/** Default toast auto-dismiss (ms). Matches ToastBox's current default. */
export const TOAST_DURATION_MS = 3000;

/** Locale + currency for Intl / toLocaleString formatting. */
export const LOCALE = 'en-IN';
export const CURRENCY_SYMBOL = '₹';

/** Brandfetch client id (currently inline in constants/visitorConstants.ts). */
export const BRANDFETCH_CLIENT_ID = '1dxbfHSJFAPEGdCLU4o5B';
